import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ModalState } from "src/hooks/useModal";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { confirmationPopupTrns } from "./trns";
import { ModalWindowV2 } from "../ModalWindowV2";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";

export interface Props extends ModalState {
  description?: string | Ii18nInterpolationObject;
  onConfirm: VoidFunction;
  onClose?: VoidFunction;
}

export const ConfirmationPopupV2: FC<Props> = ({
  description,
  onConfirm,
  onClose,
  ...modalProps
}) => {
  const { t } = useTranslation();

  const translatedDesc =
    typeof description === "string"
      ? description
      : t(description?.i18nKey, description?.i18nParams);

  const handle = (cb: VoidFunction) => () => {
    cb?.();
    modalProps.closeModal();
  };

  return (
    <ModalWindowV2
      {...modalProps}
      className="max-w-90 w-full"
      isActiveCloseClickOutside={true}
      isShownCloseButton={false}
      isActivePortal
    >
      <div className="flex flex-col gap-5 px-5 py-10 text-center text-xl bg-purple-lighter font-medium rounded-20">
        <p className="text-purple-base">
          {description ? translatedDesc : t(confirmationPopupTrns.description)}
        </p>
        <div className="flex items-center gap-4">
          <Button
            variant={ButtonVariants.SECONDARY}
            onClick={handle(onClose)}
            className="flex-1 py-3"
          >
            {t(confirmationPopupTrns.noButton)}
          </Button>
          <Button
            variant={ButtonVariants.PRIMARY}
            onClick={handle(onConfirm)}
            className="flex-1 py-3"
          >
            {t(confirmationPopupTrns.yesButton)}
          </Button>
        </div>
      </div>
    </ModalWindowV2>
  );
};
